var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('b-card',[_c('h3',[_vm._v(" Conexión DIAN ")]),_c('config1Empresa'),_c('Config2Software'),_c('config3Certificado')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }